import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';
import { getTriggerButtonStyle } from '../../context';
import { TriggerButtonContent } from '../triggerButtonContent';

export const TriggerButton = (props: React.PropsWithChildren<{
  fontSize?: ouiStyle.InStyleWithMediaQueries['fontSize'],
  flexGrow?: ouiStyle.InStyleWithMediaQueries['flexGrow'],
  flexShrink?: ouiStyle.InStyleWithMediaQueries['flexShrink'],
  flexBasis?: ouiStyle.InStyleWithMediaQueries['flexBasis'],
  marginVertical?: ouiStyle.InStyleWithMediaQueries['marginVertical'],
  borderTopRightRadius?: ouiStyle.InStyleWithMediaQueries['borderTopRightRadius'],
  borderBottomRightRadius?: ouiStyle.InStyleWithMediaQueries['borderBottomRightRadius'],
  borderTopLeftRadius?: ouiStyle.InStyleWithMediaQueries['borderTopLeftRadius'],
  borderBottomLeftRadius?: ouiStyle.InStyleWithMediaQueries['borderBottomRightRadius'],
  baseBackgroundColor?: ouiStyle.Constants.Colors,
  baseBorderColor?: ouiStyle.Constants.Colors,
  baseHoverBackgroundColor?: ouiStyle.Constants.Colors,
  disabled?: boolean,
  onClick: React.MouseEventHandler<HTMLButtonElement>,
  done: boolean,
  hasError: boolean,
}>) => {
  const {
    fontSize = 'm',
    flexGrow,
    flexShrink,
    flexBasis,
    marginVertical,
    borderTopRightRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderBottomLeftRadius,
    baseBackgroundColor = ouiStyle.Constants.Colors.accent,
    baseBorderColor = ouiStyle.Constants.Colors.accent,
    baseHoverBackgroundColor = ouiStyle.Constants.Colors.accentShaded,
    disabled,
    onClick,
    done,
    hasError,
    children,
  } = props;
  const buttonStyle = getTriggerButtonStyle({
    done,
    hasError,
    disabled,
    baseBackgroundColor,
    baseBorderColor,
    baseHoverBackgroundColor,
  });
  return (
    <ouiDom.Button.Button
      type="button"
      fontSize={fontSize}
      onClick={onClick}
      disabled={buttonStyle.disabled}
      backgroundColor={buttonStyle.backgroundColor}
      color={ouiStyle.Constants.Colors.inverted}
      borderColor={buttonStyle.borderColor}
      hoverBackgroundColor={buttonStyle.hoverBackgroundColor}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      flexBasis={flexBasis}
      marginVertical={marginVertical}
      borderTopRightRadius={borderTopRightRadius}
      borderBottomRightRadius={borderBottomRightRadius}
      borderTopLeftRadius={borderTopLeftRadius}
      borderBottomLeftRadius={borderBottomLeftRadius}
    >
      <TriggerButtonContent
        done={done}
        hasError={hasError}
      >
        {children}
      </TriggerButtonContent>
    </ouiDom.Button.Button>
  );
};
